import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_DDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'disease1_Name',
    'ngenes_diseaseID_1',
    'nvariants_diseaseID_1',
    'disease1ClassName_DO',
    'disease1ClassName_HPO',
    'disease1ClassName_MSH',
    'disease1ClassName_UMLS',
    'disease1_Type',
    'disease2_Name',
    'ngenes_diseaseID_2',
    'nvariants_diseaseID_2',
    'disease2ClassName_DO',
    'disease2ClassName_HPO',
    'disease2ClassName_MSH',
    'disease2ClassName_UMLS',
    'disease2_Type',
    'shared_genes',
    'jaccard_genes',
    'pvalue_jaccard_genes',
    'shared_variants',
    'jaccard_variants',
    'pvalue_jaccard_variants',
    'sokal',
    'ddaRelation',
    'disease1_UMLSCUI',
    'disease2_UMLSCUI',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'disease1_Name',
    'disease2_Name',
    'ngenes_diseaseID_2',
    'nvariants_diseaseID_2',
    'disease2ClassName_MSH',
    'shared_genes',
    'jaccard_genes',
    'pvalue_jaccard_genes',
    'shared_variants',
    'jaccard_variants',
    'pvalue_jaccard_variants',
    'sokal',
    'ddaRelation',
  ],
};